exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Shade-module__shade___1zGup{background-color:rgba(44,45,49,.5);position:fixed;z-index:100;top:0;left:0;width:100vw;height:var(--app-height)}", ""]);

// exports
exports.locals = {
	"shade": "Shade-module__shade___1zGup"
};